f = require 'effing'
assert = require 'app/scripts/lib/assert'
pattern = require 'matchbook'
_ = require 'underscore'

lookupPath = (obj, path) ->
  cursor = obj
  for key in path
    if !cursor.hasOwnProperty(key)
      return undefined
    cursor = cursor[key]
  return cursor

lookupString = (strings, keyPath) ->
  val = lookupPath strings, keyPath
  if !val?
    return undefined

  assert (typeof val == 'string'), "key #{keyPath.join('.')} did not resolve to a string"
  val

class Hole
  constructor: (@key) ->

class Literal
  constructor: (@value) ->

# Does not currently allow literal curly braces to appear in templates.
# Doing that requires escaping which requires lookbehind *or* reversing +
# lookahead and I'm not gonna do that right now so screw it.
parseFormatString = (formatString) ->
  # capturing matches in split tested in
  # FF 34, Chrome 39, Safari 8, IE 10
  formatString.split(/(\{[^{}]+\})/).map (group) ->
    if group.length == 0
      return null
    if group[0] == '{'
      new Hole(group.substr(1, group.length - 2))
    else
      new Literal(group)
  .filter f.id

normalizeKeyPath = pattern (match) ->
  match [String], f.method('split', '.')
  match [Array], f.id

lookup = (strings, keyPath, visitor) ->
  keyPath = normalizeKeyPath(keyPath)
  formatString = lookupString strings, keyPath

  if !formatString?
    return undefined

  parseFormatString formatString

map = (coll, fn) -> coll.map(f.choke(1, fn))

makeVisitor = (onLiteral, onHole) -> (holesAndLiterals, args...) ->
  map holesAndLiterals, pattern (match) ->
    match [Hole], ({ key }) -> onHole(key, args...)
    match [Literal], ({ value }) -> onLiteral(value, args...)

visit = (strings, keyPath, visitor, args...) ->
  holesAndLiterals = lookup(strings, keyPath)
  if !holesAndLiterals?
    return undefined
  visitor(holesAndLiterals, args...)

module.exports = { normalizeKeyPath, lookup, makeVisitor, visit }
